import type { FaireProductEntity } from "../../entity_types/product";

export const p_68vynpggp3: FaireProductEntity = {
  token: "p_68vynpggp3",
  type: "product",
  name: "Essential Magnesium - Calming Magnesium Stress Relief",
  brandToken: "b_sfmertj2fk",
  brandName: "Organifi",
  imageUrl:
    "https://cdn.faire.com/fastly/df12e3909a88939b6771585dd86ee84e6211900087c1cf72097b62701a09d1e1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3473b85bf397b346a3977e3080b32fc600da75e6bf76ce85710a1f609321c1b.png",
    "https://cdn.faire.com/fastly/55ecdef06e00a8b51d28f1eddd665067a8cdb5873ce889929ecb7397febd9027.png",
    "https://cdn.faire.com/fastly/f1375efcd720f9b912a4c8a8feb90439f1348938be89dde31f74f028cbf66078.png",
  ],
  priceDollars: 14.99,
  description:
    "Magnesium Glycinate - 150 mg\n\nA daily dose of high-absorption magnesium in easy-to-take capsules -- gentle on digestion, strong on support for your body and mind.\n\nSupports strong bones and healthy muscles.\nPromotes nerve health and communication.\nHelps boost natural cellular energy.\n\nThe Mineral of Life\nAs time passes, we tend to get less magnesium in our bodies. This is due to issues with diet and countless environmental factors. When we aren’t getting enough, we feel sluggish – like we’re just not functioning as well as we could be. Give your body the nourishment it needs, and it’ll reward you.\n\nYour body loves magnesium. It helps you feel strong from your head to your toes and everywhere in between. It helps you feel amazingly alive because it’s a co-factor in hundreds of bodily functions. It’s the fourth most abundant mineral in your entire body… unless you’re not getting enough. That’s why we made these soft gel capsules – to put the power back in your hands, and into your body.",
  tags: [],
  msrpDollars: 29.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:25.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
